import { getConfigTenant, isCorpTenant } from "@capone/common";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import { ButtonWrap, Icon, IconName, useDeviceTypes } from "halifax";
import React from "react";
import { PackagesInfoModal } from "..";
import { CORPORATE_INFO_MODAL_CTA_TEXT, INFO_MODAL_CTA_TEXT } from "../../textConstants";
import "./styles.scss";

export interface HowPackagesWorkProps {
  className?: string;
}

export const HowPackagesWork = ({ className }: HowPackagesWorkProps) => {
  const [packagesInfoModalOpen, setPackagesInfoModalOpen] =
    React.useState(false);

  const { matchesMobile } = useDeviceTypes();
  const isCorporate = isCorpTenant(getConfigTenant());

  const getInfoModalCtaText = () => {
    if (!isCorporate) {
      return INFO_MODAL_CTA_TEXT;
    }
    return CORPORATE_INFO_MODAL_CTA_TEXT;
  };

  return (
    <Box
      className={clsx("how-packages-work-container", className, {
        mobile: matchesMobile && isCorporate,
      })}
    >
      <ButtonWrap
        className="packages-info-cta"
        onClick={() => setPackagesInfoModalOpen(true)}
      >
        <Box className={clsx("new-tag", { corporate: isCorporate })}>New</Box>
        <Typography className="packages-info-cta-text">
          {getInfoModalCtaText()}
        </Typography>
        <Icon name={IconName.InfoCircle} />
      </ButtonWrap>

      <PackagesInfoModal
        open={packagesInfoModalOpen}
        setOpen={setPackagesInfoModalOpen}
      />
    </Box>
  );
};
